import { FormEvent, useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import { useAlert } from 'react-alert'

import {
  CustomerModel,
  ObservationModel,
  SynthesisModel
} from '../../../domain/models'
import {
  fetchCustomer,
  fetchBehavioralObservation,
  updateBehavioralObservation,
  fetchSynthesis,
  updateSynthesis,
  saveNewSynthesis
} from '../../../main/usecases'

import { goToUrl, maskCpf } from '../../utils'
import {
  Button,
  EditorCard,
  ServicesHeader,
  SubHeader,
  Textarea
} from '../../components'

import {
  IconSaveSvg,
  IconReturnSvg,
  IconDocumentSvg,
  IconDownloadSvg
} from '../../assets/icons/svgComponents'

import * as S from './styles'

const BehavioralObservation = ({ match }: any) => {
  const [customer, setCustomer] = useState<CustomerModel>()
  const [observation, setObservation] = useState<ObservationModel>()
  const [synthesis, setSynthesis] = useState<SynthesisModel>(
    {} as SynthesisModel
  )
  const [otherSynthesis, setOtherSynthesis] = useState<SynthesisModel>(
    {} as SynthesisModel
  )
  const [synthesisData, setSynthesisData] = useState('')
  const history = useHistory()
  const alert = useAlert()
  useEffect(() => {
    ;(async () => {
      try {
        const responseCustomer = await fetchCustomer({
          id: match?.params?.id
        }).load()
        const responseObservation = await fetchBehavioralObservation({
          id: match?.params?.idassessment
        }).load()
        setCustomer(responseCustomer)
        console.log(responseObservation)
        setSynthesisData(responseObservation.sintese)
        setObservation(responseObservation)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [match.params.id, match?.params?.idassessment])
  useEffect(() => {
    ;(async () => {
      try {
        const responseFetchSynthesis = await fetchSynthesis({
          cdAvaliacao: match?.params?.idassessment,
          type: 2
        }).load()
        const responseFetchOtherSynthesis = await fetchSynthesis({
          cdAvaliacao: match?.params?.idassessment,
          type: 3
        }).load()
        setSynthesis(responseFetchSynthesis)
        setOtherSynthesis(responseFetchOtherSynthesis)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [match?.params?.idassessment])

  const handleSaveNewPlaceholderInBehavioralObservation = async () => {
    const body = {
      ...(!synthesis.modeloAdm && {
        cdTextoSintese: synthesis?.cdTextoSintese
      }),
      tipoSintese: {
        cdTipoSintese: 2
      },
      texto: synthesisData
    }

    try {
      if (!synthesis.modeloAdm) {
        const response = await updateSynthesis({
          cdAvaliacao: match?.params?.idassessment
        }).update(body)
        alert.show('Salvo', {
          type: 'success',
          timeout: 4000
        })

        setSynthesis(response)
      } else {
        const response = await saveNewSynthesis({
          cdAvaliacao: match?.params?.idassessment
        }).post(body)
        alert.show('Salvo', {
          type: 'success',
          timeout: 4000
        })

        setSynthesis(response)
      }
      setObservation((prev: any) => ({
        ...prev,
        sintese: synthesisData
      }))
    } catch (error) {
      console.error(error)
      alert.show('Erro ao Salvar', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  const handleSaveNewPlaceholderInOtherObservations = async () => {
    const body = {
      ...(!otherSynthesis.modeloAdm && {
        cdTextoSintese: otherSynthesis?.cdTextoSintese
      }),
      tipoSintese: {
        cdTipoSintese: 3
      },
      texto: observation?.demaisObservacoes
    }

    try {
      if (!otherSynthesis.modeloAdm) {
        const response = await updateSynthesis({
          cdAvaliacao: match?.params?.idassessment
        }).update(body)
        alert.show('Salvo', {
          type: 'success',
          timeout: 4000
        })

        setOtherSynthesis(response)
      } else {
        const response = await saveNewSynthesis({
          cdAvaliacao: match?.params?.idassessment
        }).post(body)
        alert.show('Salvo', {
          type: 'success',
          timeout: 4000
        })

        setOtherSynthesis(response)
      }
    } catch (error) {
      console.error(error)
      alert.show('Erro ao Salvar', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault()

    const body = {
      cdObservacaoComportamental: observation?.cdObservacaoComportamental,
      sintese: synthesisData,
      demaisObservacoes: observation?.demaisObservacoes
    }

    try {
      await updateBehavioralObservation({
        id: match?.params?.idassessment
      }).update(body)
      alert.show('Salvo', {
        type: 'success',
        timeout: 4000
      })
      goToUrl(history, `/meus-pacientes/${match?.params?.id}/prontuario`)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <S.Wrapper>
      {customer && (
        <SubHeader
          name={customer.nome}
          cpf={maskCpf(customer.cpf)}
          page="Voltar"
          link={`/meus-pacientes/${match?.params?.id}/prontuario?serviceId=${match.params.idservico}`}
        />
      )}
      <S.CardContainer>
        <ServicesHeader onClick={onSubmit} title="Observação Comportamental" />
        <EditorCard
          data={synthesisData}
          setData={setSynthesisData}
          title="Síntese das observações comportamentais"
          hasHelp
          onInputPlaceholder={() => {
            setSynthesisData(synthesis.texto || '')
          }}
          handleSaveNewPlaceholder={
            handleSaveNewPlaceholderInBehavioralObservation
          }
          placeholder={synthesis.texto}
          tooltipText="Insira aqui as observações comportamentais do paciente. Este texto poderá ser utilizado na construção dos documentos psicológicos."
        />
        <S.Resume>
          <S.TextareaContainer>
            <Textarea
              labelColor="#4F4F4F"
              labelWeight={600}
              label="Demais observações comportamentais"
              name="interview-summary"
              onChange={(e: any) =>
                setObservation((prev: any) => ({
                  ...prev,
                  demaisObservacoes: e.target.value
                }))
              }
              value={observation?.demaisObservacoes}
              placeholder={otherSynthesis.texto}
            />
            <S.TextareaButtonsContainer>
              <button
                onClick={() =>
                  setObservation((prev: any) => ({
                    ...prev,
                    demaisObservacoes: `${otherSynthesis.texto}`
                  }))
                }
                data-tip="Inserir texto modelo"
                className="help-button"
              >
                <IconDocumentSvg />
              </button>
              <button
                data-tip="Salvar texto atual como modelo"
                className="help-button"
                onClick={handleSaveNewPlaceholderInOtherObservations}
              >
                <IconDownloadSvg />
              </button>
              <button
                data-tip="Informação particular que não será utilizada nos documentos"
                className="help-button"
              >
                ?
              </button>
              <ReactTooltip
                type="light"
                place="top"
                effect="solid"
                className="tooptip-custom"
              />
            </S.TextareaButtonsContainer>
          </S.TextareaContainer>
        </S.Resume>
        <S.ButtonsContainer>
          <Button
            initialIcon={<IconSaveSvg />}
            className="button-save"
            onClick={onSubmit}
          >
            Salvar
          </Button>
          <Button
            initialIcon={<IconReturnSvg />}
            hasSecodaryButton
            className="button-return-to-list"
          >
            <Link
              to={`/meus-pacientes/${match?.params?.id}/prontuario?serviceId=${match.params.idservico}`}
            >
              Retornar à listagem
            </Link>
          </Button>
        </S.ButtonsContainer>
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default BehavioralObservation
